import React from 'react';

const Background = () => {
  return (
    <>
      <div className='w-[350px] h-[350px] bg-[#eeeeee] absolute top-[40%] left-[60%] blur-[40px] z-0 opacity-5 rounded-full'></div>
      <div className='w-[400px] h-[400px] bg-[#eeeeee] absolute top-[20%] left-[20%] blur-[40px] z-0 opacity-5 rounded-full'></div>
    </>
  );
};

export default Background;
